import { Outlet } from 'react-router-dom';

import { Button, Modal } from 'antd';

import { useAccounts } from '@/hooks/useAccounts';

const ORBITA_URL = 'https://orbita.eduzz.com';

const goToOrbita = () => {
  window.location.href = ORBITA_URL;
};

const goToSupport = () => {
  window.location.href = 'https://suporte.eduzz.com';
};

export default function AuthRequired() {
  const { isAuthenticated, documentInactive, userAlreadyRegistered } = useAccounts();

  if (documentInactive) {
    return (
      <Modal
        open
        closable={false}
        maskClosable={false}
        keyboard={false}
        title='Pendência na sua documentação'
        footer={
          <div className='flex justify-end'>
            <Button id='document-inactive-ok' type='primary' onClick={goToOrbita}>
              OK
            </Button>
          </div>
        }
      >
        <p>Olá!</p>
        <p>
          Identificamos uma pendência no seu documento junto à Receita Federal. É preciso resolver isso antes de
          continuar.
        </p>
        <p>
          <strong>Como regularizar:</strong>
        </p>
        <ol className='list-decimal space-y-1 pl-5'>
          <li>Acesse o site da Receita Federal ou o portal gov.br;</li>
          <li>Verifique sua situação cadastral e siga as orientações de regularização;</li>
          <li>
            Após a aprovação, o prazo de reflexo nas bases é de até 5 dias úteis (online) ou 10 dias úteis (presencial).
          </li>
        </ol>
        <p>Depois de regularizar, volte à plataforma e retome o processo de onde parou.</p>
        <p>
          Caso tenha ficado com alguma dúvida, nosso time está pronto para te ajudar! Acione o suporte ou encontre tudo
          o que precisa na nossa Central de Ajuda.
        </p>
        <p>Abraços!</p>
      </Modal>
    );
  }

  if (userAlreadyRegistered) {
    return (
      <Modal
        open
        closable={false}
        maskClosable={false}
        keyboard={false}
        title='Usuário já possui uma conta vinculada ao mesmo documento'
        footer={
          <div className='flex justify-end'>
            <Button id='user-already-registered-ok' type='primary' onClick={goToSupport}>
              OK
            </Button>
          </div>
        }
      >
        <p>Olá!</p>
        <p>
          Identificamos que você já está registrado na plataforma com o mesmo documento. Por favor, entre em contato com
          o suporte para mais informações.
        </p>
      </Modal>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return <Outlet />;
}
